import { BrandType } from 'noddi-types';
import { ErrorCodes } from 'noddi-ui-web';
import { CountryCodeType } from 'noddi-util';

import { RegNumberSearchField } from './RegNumberSearchField';
import { FoundCar, useRegNumberSearch } from './useRegNumberSearch';

type Props = {
  addCar: (carProps: FoundCar) => void;
  translations: {
    add: string;
    placeholder: string;
    invalidLicensePlate: string;
    alreadyExists: string;
  };
  countryCode?: CountryCodeType;
  errorCodes?: ErrorCodes;
  selectedLicensePlateNumbers?: string[];
  brandDomain?: BrandType;
};

/** Self-contained plate search. Use `useRegNumberSearch` + `RegNumberSearchField` when the page must submit the typed plate. */
export const RegNumberSearch = ({
  addCar,
  translations,
  countryCode,
  errorCodes,
  selectedLicensePlateNumbers,
  brandDomain
}: Props) => {
  const search = useRegNumberSearch({ countryCode, selectedLicensePlateNumbers, brandDomain });

  return (
    <RegNumberSearchField search={search} onCarFound={addCar} translations={translations} errorCodes={errorCodes} />
  );
};
